import { Injectable, signal } from '@angular/core';

import { map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthService {

  private readonly storage$ = of(sessionStorage);

  private readonly signals = {
    token: signal<string | undefined>(undefined),
    user: signal<any | undefined>(undefined),
    isAuth: signal<boolean>(false),
  };

  verifyToken(token: string): Observable<boolean> {
    return this.storage$.pipe(
      map(() => {
        this.signals.isAuth.set(
          true
        );

        if (this.signals.isAuth()) {
          this.signals.token.set(token);
        }

        return this.signals.isAuth();
      })
    );
  }

  getAuthUser(): any | undefined {
    return this.signals.user();
  }

  setAuthUser(): void {
    if (this.signals.isAuth()) {
      if (this.signals.user()) return;

      this.signals.user.set({
        id: 1,
        name: 'Centro Médico Haina',
        email: 'email@example.com',
        slug: 'do-centro-haina',
      } as any);
    }
  }
}
